








import {Component, Vue} from 'vue-property-decorator';
import {mapGetters, mapActions} from 'vuex';

import Assets from '@/constants/assets.ts';

@Component({
    computed: {
        ...mapGetters({
            mainContainerColor: 'getClientMainContainerColor',
        }),
    },
    methods: {
        ...mapActions({
            setClientMainContainerColorGreyCustom:
                'setClientMainContainerColorGreyCustom',
        }),
    },
})
export default class ClientLayout extends Vue {
    private assets = Assets;
    private mainContainerColor!: any;
    private setClientMainContainerColorGreyCustom!: any;

    private created() {
        this.setClientMainContainerColorGreyCustom();
        this.changeFavIcon();
    }

    get backgroundImage() {
        return {
            'background-image': `url("${this.assets.backgroundDecorationLight}")`,
            'background-repeat': 'no-repeat',
            'background-position-x': 'left',
            'background-position-y': '23px',
            'background-size': '325px 80vh',
        };
    }

    changeFavIcon() {
        // const favicon = document.getElementById('level-up-favicon');
        // try {
        //   (favicon as HTMLAnchorElement).href = 'https://levelupdesarrollo.com/wp-content/uploads/2020/09/UP-19.png';
        // } catch (_) {}
    }
}
